@if (isFormControlReady) {
  <form class="form-group" [formGroup]="formGroupInput" [class.has-label]="label">
    @if (label) {
      <label for="region-country-select">{{ label | translate }}</label>
    }
    <p-treeSelect
      id="region-country-select"
      [(ngModel)]="selectedNodes"
      [ngModelOptions]="{ standalone: true }"
      (ngModelChange)="onSelectionChange($event)"
      [options]="treeNodes"
      [filter]="true"
      (onClear)="clearFilter()"
      [showClear]="true"
      [loading]="loading"
      fluid
      selectionMode="checkbox"
      [metaKeySelection]="false"
      display="chip"
      [scrollHeight]="'150px'"
      [panelStyle]="{ 'max-width': '240px' }"
      size="small"
      appendTo="body"
    >
      <ng-template let-node pTemplate="default">
        <div style="font-size: 12px; white-space: normal; word-break: break-word; line-height: 1.4">
          {{ node.label }}
        </div>
      </ng-template>

      @if (showAllClassesToggle) {
        <ng-template #header>
          <div class="all-classes-toggle">
            <p-checkbox
              [(ngModel)]="allClasses"
              [ngModelOptions]="{ standalone: true }"
              (onChange)="onAllClassesChange()"
              binary="true"
              inputId="all-classes-toggle"
            ></p-checkbox>
            <label for="all-classes-toggle">{{ 'FILTERS.SHOW_ALL_CLASSES' | translate }}</label>
          </div>
        </ng-template>
      }
      @if (!allClasses) {
        <ng-template #footer>
          <div class="treeselect-footer">
            <p-button
              [label]="(allCountriesSelected ? 'FILTERS.DESELECT_ALL' : 'FILTERS.SELECT_ALL') | translate"
              [text]="true"
              size="small"
              [disabled]="totalCountriesCount === 0"
              (onClick)="toggleSelectAll()"
            ></p-button>
          </div>
        </ng-template>
      }
    </p-treeSelect>
  </form>
}
